import React from "react";

export default function   H2(props) {
  return (
    <h1 className="text-lg lg:text-3xl font-medium text-secondary py-2 mb-3">
      {props.children}
    </h1>
  );
}
